export default "__VITE_ASSET__ijk4_xhE__"